import request from '@/utils/request'




/**
 * 查询销售客单价
 * @param data
 */
export function querySalesUnitPrice(params) {
  return request({
    url: '/admin/bas/querySalesUnitPrice',
    method: 'get',
    params: params
  })
}

/**
 * 查询耗卡客单价
 * @param data
 */
export function queryUseCardUnitPrice(params) {
  return request({
    url: '/admin/bas/queryUseCardUnitPrice',
    method: 'get',
    params: params
  })
}

/**
 * 查询收入分析
 * @param data
 */
export function queryIncomeAnalysis(params) {
  return request({
    url: '/admin/bas/queryIncomeAnalysis',
    method: 'get',
    params: params
  })
}
/**
 * 全部会员次数与金额查询
 * @param data
 */
export function queryAllCardClassMoneyDetail(params) {
  return request({
    url: '/admin/bas/queryAllCardClassMoneyDetail',
    method: 'get',
    params: params
  })
}
/**
 * 环比数据
 * @param data
 */
export function queryMonthOnMonthData(params) {
  return request({
    url: '/admin/bas/queryMonthOnMonthData',
    method: 'get',
    params: params
  })
}













// WEBPACK FOOTER //
// ./src/api/bas/busnessAnalysis.js